import { TFunction } from "i18next";

export function validateRequired({
  value,
  t,
}: {
  value: string | boolean | object | undefined;
  t: TFunction;
}): string | undefined {
  // Handle different value types
  if (value === undefined || value === null) {
    return t("AS:validation.required");
  }

  // For string values, check if empty or just whitespace
  if (typeof value === "string" && value.trim() === "") {
    return t("AS:validation.required");
  }

  return undefined; // Valid
}

export function validateEmail({
  value,
  t,
}: {
  value: string;
  t: TFunction;
}): string | undefined {
  const re = /\S+@\S+\.\S+/;
  return !re.test(value) ? t("AS:form.field.error.email") : undefined;
}

export function validatePhoneNumber({
  value,
  t,
}: {
  value: string;
  t: TFunction;
}): string | undefined {
  // Allow empty values (optional field)
  if (!value || value.trim() === "") {
    return undefined;
  }

  // Strict validation: only numbers and + (only at the beginning)
  const phoneRegex = /^\+?[0-9]+$/;

  if (!phoneRegex.test(value)) {
    return t("AS:form.field.error.phone");
  }

  // Check reasonable length limits
  const minLength = value.startsWith("+") ? 8 : 7; // +1234567 or 1234567
  const maxLength = 16; // reasonable international phone number limit

  if (value.length < minLength || value.length > maxLength) {
    return t("AS:form.field.error.phone");
  }

  return undefined;
}
